import instance from '@/utils/instance';

//新增反馈
export function postMemberFeedback(data) {
	return instance({
		url: `/webL_api/consumer/member/feeback/new`,
		method: 'post',
        data
	});
}

//获取反馈列表
export function getMemberFeedbackList() {
	return instance({
		url: `/webL_api/consumer/member/feeback/history`,
		method: 'get',
	});
}

//移除反馈
export function deleteMemberFeedback(data) {
	return instance({
		url: `/webL_api/consumer/member/feeback/remove/${data}`,
		method: 'delete',
	});
}

//获取反馈类型列表
export function getMemberFeedbackTypeList() {
	return instance({
		url: `/webL_api/consumer/member/feeback/type`,
		method: 'get',
	});
}